var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(!!_vm.to?'linker':'div',{tag:"div",staticClass:"menu-item",attrs:{"to":_vm.to}},[_c('div',{staticClass:"label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }